export class VenueCompany {
    id: string;

    name: string;

    abn: string;

    phone: string;

    website: string;

}
